import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import styles from './ReturnToDashboard.module.css';

interface ReturnToDashboardProps {
  inHeader?: boolean;
}

const ReturnToDashboard: React.FC<ReturnToDashboardProps> = ({ inHeader = false }) => {
  if (inHeader) {
    return (
      <Link to="/dashboard" className={styles.backToDashboard}>
        <FaArrowLeft />
        Back to Dashboard
      </Link>
    );
  }

  return (
    <div className={styles.container}>
      <Link to="/dashboard" className={styles.backToDashboard}>
        <FaArrowLeft />
        Back to Dashboard
      </Link>
    </div>
  );
};

export default ReturnToDashboard;